import * as yup from "yup";

const signatureSchema = yup.mixed()
  .default("")
  .test("required", "", (file) => {
    return file;
  });

export default signatureSchema;